import {
  Component,
  OnInit,
} from '@angular/core';

import {
  AlertController,
  ModalController,
} from '@ionic/angular';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.page.html',
  styleUrls: ['./address-list.page.scss'],
})
export class AddressListPage implements OnInit {

  // @Input() customer_id: any;
  // is_address;
  // address_list: any=[];
  // @Input() modal;
  // @Input() is_modal;
  // selected_address: any = {};
  // // temp_cusid:any;
  // customer_name: any;

  constructor(public alertCtrl: AlertController,public db:DataService,public modalCtrl: ModalController) {

  }

  ngOnInit() {
    // this.get_address();
    console.log("customer name....", this.db.Customer)
    // console.log("customer",this.temp_cusid)
  }

  // get_customer_info() {
  //   let customer_id = this.db.Customer.name;
  //   this.db.domain_customer_Info(customer_id)
  //   .subscribe((r: any) => {
  //     if(r.message)
  //       this.customer_info = r.message[0];
  //   }, error => {
  //     console.log(error)
  //   })
  // }



  // get_customers(){
  //   if(this.modal){
  //     this.customer_name = this.db.Customer.name;
  //   }
  //   else {
  //     this.customer_name = this.customer_id;
  //   }
  // }

  // async get_address() {
  //   // let customer_id;
  //   // if(this.modal)
  //   //    this.customer_id = this.db.Customer.name;
  //   // else
  //   //  this.customer_id = this.customer_id.name
  //   this.db.domain_customer_Info(this.customer_id.name).subscribe((res:any) => {
  //       console.log("address_list", res);
  //       this.address_list = res.message;
  //     },
  //     (error) => {
  //       console.log(JSON.stringify(error.json()));
  //     }
  //   );
  // }

  // async add_address() {
  //   let modal = await this.modalCtrl.create({
  //     component: AddAddressPage,
  //     cssClass: "address-popup",
  //     componentProps: {
  //       address_type: "Add",
  //       customer_id:this.customer_id
  //     },
  //   });
  //   await modal.present();
  //   let data = await modal.onWillDismiss();
  //   // if (data.data == 'success') {
  //     this.get_address();
  //     // }
  // }

  // dismiss_modal() {
  //   this.modalCtrl.dismiss();
  // }

  // async edit_address(li, index) {
  //   let modal = await this.modalCtrl.create({
  //     component: AddAddressPage,
  //     cssClass: "address-popup",
  //     componentProps: {
  //       address_type: "Edit",
  //       address_info: li,
  //       customer_data: this.customer_id
  //     },
  //   });
  //   await modal.present();
  //   let data = await modal.onWillDismiss();
  //   // if (data.data == 'success') {
  //     this.get_address();
  //     // }
  // }

  // select_address(addr) {
  //   this.modalCtrl.dismiss(addr);
  // }

  // deleteData(li, index) {
  //   this.delete_address(li, index);
  // }

  // delete_address(li, index) {
  //   var data = {
  //     id: li.name,
  //     customer: this.customer_id.name,
  //   };
  //   this.db.delete_address(data,1).subscribe((res: any) => {
  //     console.log(res);
  //       this.address_list.splice(index, 1);
  //       this.get_address();
  //     },
  //     (error) => {
  //       console.log(JSON.stringify(error.json()));
  //     }
  //   )
  // }

  // async confirm_delete(li, index) {
  //   let alert = await this.alertCtrl.create({
  //     header: 'Alert.!',
  //     message: 'Are you sure want to delete this address..?',
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         handler: () => { this.alertCtrl.dismiss() }
  //       },
  //       {
  //         text: 'yes',
  //         handler: () => {
  //           this.delete_address(li, index);
  //         }
  //       }
  //     ]

  //   })
  //   await alert.present();
  // }


  // select_customer(adr){
  //   this.modalCtrl.dismiss(adr)
  // }

  // close(){
  //   this.modalCtrl.dismiss();
  // }

  // async add_address() {
  //   let modal = await this.modalCtrl.create({
  //     component: AddAddressPage,
  //     cssClass: "address-popup",
  //     componentProps: {
  //       address_type: 'Add',
  //       customer_id:this.customer_id
  //     },
  //   });
  //   await modal.present();
  //   let data = await modal.onWillDismiss();
  //   // if (data.data == 'success') {
  //     this. get_address();
  //     // }
  // }

  // dismiss_modal() {
  //   this.modalCtrl.dismiss();
  // }

  // async edit_address(li, index) {
  //   let modal = await this.modalCtrl.create({
  //     component: AddAddressPage,
  //     cssClass: "address-popup",
  //     componentProps: {
  //       address_type: "Edit",
  //       address_info: li,
  //       customer_data: this.customer_id
  //     },
  //   });
  //   await modal.present();
  //   let data = await modal.onWillDismiss();
  //   // if (data.data == 'success') {
  //     this. get_address();
  //     // }
  // }

  // delete_address(li, index) {
  //   var data = {
  //     id: li.name,
  //     customer: this.customer_id.name
  //   };
  //   this.db.delete_address(data,1).subscribe((res: any) => {
  //     console.log(res);
  //       this.customer_info.address.splice(index, 1);
  //       this.get_customer_info();
  //     },
  //     (error) => {
  //       console.log(JSON.stringify(error.json()));
  //     }
  //   )
  // }

  // async confirm_delete(li, index) {
  //   let alert = await this.alertCtrl.create({
  //     header: 'Alert.!',
  //     message: 'Are you sure want to delete this address..?',
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         handler: () => { this.alertCtrl.dismiss() }
  //       },
  //       {
  //         text: 'yes',
  //         handler: () => {
  //           this.delete_address(li, index);
  //         }
  //       }
  //     ]

  //   })
  //   await alert.present();
  // }

}
